import React from "react";
import LogoImg from "../../assets/img/logo-LLOYDS.png";

function GlobalLogoLLOYDS({logoClass}) {
  return (
    <div className={logoClass}>
      <img src={LogoImg} alt="surya-logo-llc" />
    </div>
  );
}

export default GlobalLogoLLOYDS;
